<template>
  <div>
    <title-unpaid title="Facturas Abertas"></title-unpaid>
      <unpaid-component></unpaid-component>
  </div>
</template>

<script>
import Title from "../geral/Title";
import UnpaidComponent from "./invoices/UnpaidComponent";
export default {
  name: "UnpaidInvoice",
  components: {UnpaidComponent, "title-unpaid": Title }
};
</script>

<style scoped></style>
